import {Component, EventEmitter, Input, Output} from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { getTermsConditionUrl } from '../../terms-condition';

@Component({
  selector: 'app-termandcondition',
  templateUrl: './termandcondition.component.html',
  styleUrls: ['./termandcondition.component.css']
})
export class TermandconditionComponent {
    @Input() termsAndConditionAccepted = false;
    @Input() isReadOnly = false;
    @Output() termAndConditionStatusChange = new EventEmitter<boolean>();
    get tNc() {
      return getTermsConditionUrl();
    };

    constructor(public platformLocation: PlatformLocation) { }

    onChange() {
        this.termAndConditionStatusChange.emit(this.termsAndConditionAccepted);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/ui/termandcondition/termandcondition.component.ts